enum Devices {
  Desktop = "DESKTOP",
  Mobile = "MOBILE"
}

export default Devices;
